<div class="html-editor-wrapper row" *ngIf="customOptions">
    <div class="col-sm-12 {{viewOnly ? 'disabled' : ''}}">
        <div class="header-container">
            <label class="{{required ? 'field-required' : ''}} title">
                {{'forms.common.' + customOptions.label | translate}}
            </label>

            <button *ngIf="customOptions.isMultiple && !viewOnly" class="btn btn-outline-primary btn-sm mb-2 editgrid-add-btn"
                title="{{'forms.common.Add Another' | translate}}" role="button" (click)="addRow()">
                <span class="fa fa-plus" aria-hidden="true"></span>
            </button>
        </div>

        <ng-container *ngIf="customOptions.isMultiple;else singleValue">
            <div class="d-flex mt-row" *ngFor="let item of multipleModel;let i = index">
                <div class="flex-grow-1">
                    <p-editor name="{{formioComponent?.id}}-{{i}}" [style]="{'height':'220px'}" [required]="required"
                        [(ngModel)]="item.value" [readonly]="viewOnly" (onTextChange)="onTextChange($event,i)">
                    </p-editor>
                </div>
                <div *ngIf="!viewOnly">
                    <i title="{{'forms.common.Delete' | translate}}" class="fa fa-trash removeRow"
                        style="padding-top: 10px"  (click)="deleteRow(i)"></i>
                </div>
            </div>
        </ng-container>

        <ng-template #singleValue>
            <p-editor [name]="formioComponent?.id" [style]="{'height':'220px'}" [required]="required"
                [(ngModel)]="model" [readonly]="viewOnly" (onTextChange)="onTextChange($event)">
            </p-editor>
        </ng-template>

    </div>
</div>